import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeTab } from '../../../../Features/reportAnalysisSlice';
import ProductInsightsListItem from './ProductInsightsListItem';

function ProductInsights() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const dashboard = useSelector((state) => state.dashboard.dashboard.dashboard);

    const handleButtonClick = () => {
        dispatch(changeTab('inventory'));
        navigate('/report-and-analytics');
    }

    return (
        <div  className="border border-[#EAEAEA] rounded-lg col-span-3 min-h-[50vh] pt-4 pb-2 flex flex-col">
            <div className="flex items-center justify-between px-4">
                <h1 className="text-[#121212] font-semibold text-base">Product Insights</h1>

                <button onClick={handleButtonClick} className="p-0 outline-none border-none text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all data</button>
            </div>

            <div className="flex flex-col mt-3">
                <div className="list-header flex items-center text-[14px] leading-6 text-[#666666] font-semibold bg-[#F5F5F5]">
                    <h2 className="w-[56%] pl-4 pr-[10px] py-2 uppercase">products</h2>
                    <h2 className="w-[22%] pl-4 pr-[10px] py-2">Total Orders</h2>
                    <h2 className="w-[22%] pl-4 pr-[10px] py-2">In Stock</h2>
                </div>
            </div>

            {
                Object.keys(dashboard).length > 0 && 
                (
                    dashboard.productInsights.length > 0 && 
                    dashboard.productInsights.map(product => {
                        return (
                            <ProductInsightsListItem 
                                key={product.id} 
                                product={product} 
                            />
                        )
                    })
                )
            }
        </div>
    );
}

export default ProductInsights;
